<template>
  <div>
    <a-table
      :columns="columns"
      :data-source="form.attachement"
      rowKey="id"
      :pagination="false"
      tableLayout="fixed"
    >
      <template slot="type" slot-scope="text, record">
        <span class="required-label">
          <span
            class="required-star"
            >*</span
          >
          {{ record.type }}
        </span>
      </template>
      <template slot="file" slot-scope="text, record">
        <div class="file-cell-wrapper">
          <a-upload
            action="https://api.jssyjt.net/external-service-center/uploadFile/attachment"
            :headers="uploadHeaders"
            list-type="picture-card"
            :file-list="record.files"
            @preview="handlePreview"
            @change="(e) => handleAttachmentChange(e, record)"
            :disabled="!isEditable"
            :multiple="true"
            :show-upload-list="true"
            accept=".jpg,.png,.jpeg"
            :data="{ uploadType: record.uploadType }"
          >
            <span v-if="!record.files || record.files.length === 0">
              <div v-if="isEditable" class="upload-link">请上传附件</div>
              <div v-else>--</div>
            </span>
          </a-upload>
          <a-modal
            :visible="previewVisible"
            :footer="null"
            @cancel="previewHandleCancel"
            width="900px"
            class="preview-image-modal"
            centered
          >
            <div class="preview-wrapper">
              <img :src="previewImage" />
            </div>
          </a-modal>
        </div>
      </template>

      <template slot="status" slot-scope="text, record">
        <span v-if="getUploadedFiles(record).length > 0" class="success">
          已上传（{{ getUploadedFiles(record).length }} 个）
        </span>
        <span v-else class="warning">未上传</span>
      </template>

      <template slot="action" slot-scope="text, record">
        <a-upload
          v-if="isEditable"
          :file-list="record.files"
          action="https://api.jssyjt.net/external-service-center/uploadFile/attachment"
          @change="(e) => handleAttachmentChange(e, record)"
          :headers="uploadHeaders"
          :multiple="true"
          :show-upload-list="false"
          accept=".jpg,.png,.jpeg"
          :data="{ uploadType: record.uploadType }"
        >
          <a-button type="default" size="small" class="upload-btn">
            <a-icon type="upload" />
            上传材料
          </a-button>
        </a-upload>
        <template v-else> -- </template>
      </template>
    </a-table>
    <div class="form-tip">
      提示：允许添加
      jpg,jpeg,png，格式文件，建议上传不超过2M，建议上传尺寸为640*472或同等比例横向图片
    </div>
  </div>
</template>

<script>
import storage from "store";
import { ACCESS_TOKEN } from "@/store/mutation-types";
export default {
  props: {
    form: {
      type: Object,
      default: () => null,
    },
    isEditable: {
      type: Boolean,
      default: () => true,
    },
  },
  computed: {
    uploadHeaders() {
      const token = storage.get(ACCESS_TOKEN);
      return {
        Authorization: token ? token : "",
      };
    },
  },
  data() {
    return {
      columns: [
        { title: "编号", dataIndex: "id", width: 80 },
        {
          title: "附件类型",
          dataIndex: "type",
          width: 260,
          scopedSlots: { customRender: "type" },
        },
        {
          title: "附件信息",
          dataIndex: "file",
          width: 450,
          scopedSlots: { customRender: "file" },
        },
        {
          title: "状态",
          dataIndex: "status",
          width: 140,
          scopedSlots: { customRender: "status" },
        },
        {
          title: "操作",
          dataIndex: "action",
          width: 140,
          scopedSlots: { customRender: "action" },
        },
      ],
      previewVisible: false,
      previewImage: undefined,
    };
  },
  methods: {
    getUploadedFiles(record) {
      if (!record.files || !record.files.length) return [];
      return record.files.filter((f) => f.status === "done");
    },
    //上传附件
    handleAttachmentChange({ fileList }, record) {
      const newList = fileList.map((item) => {
        if (item.response != null) {
          if (item.response.code == "200") {
            return {
              uid: item.uid,
              name: item.name,
              status: "done",
              url: item.response.data,
            };
          }
          if (item.response.code == "508") {
            setTimeout(() => {
              this.$notification.warning({
                message: `上传失败`,
                description: item.response.msg,
              });
            }, 500);
            return {
              uid: item.uid,
              name: item.name,
              status: "error",
              url: undefined,
            };
          } else {
            return {
              uid: item.uid,
              name: item.name,
              status: "error",
              url: undefined,
            };
          }
        } else {
          return item;
        }
      });

      // ⭐ 写回当前行
      this.$set(record, "files", newList);
    },

    //预览
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },

    previewHandleCancel() {
      this.previewVisible = false;
    },
  },
};
</script>

<style scoped>
.upload-link {
  color: red;
}

.success {
  color: #52c41a;
}

.warning {
  color: #fa8c16;
}
.upload-btn {
  display: inline-flex;
  align-items: center;
}

.upload-btn .anticon {
  font-size: 14px;
  margin-right: 6px;
}

.required-label {
  display: inline-flex;
  align-items: center;
}

.required-star {
  color: #ff4d4f;
  margin-right: 4px;
  font-size: 14px;
  line-height: 1;
}

.file-cell-wrapper /deep/ .ant-upload-list-item-name {
  position: relative;
  top: 3px;
  display: inline-block;
  max-width: 450px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.form-tip {
  margin-top: 10px;
  font-size: 13px;
  color: #8c8c8c;
  line-height: 20px;
}
</style>